import { useUsers } from "./use-users";
import { UsersView } from "./view-users";

/** Liga o ViewModel à View da aba Usuários; o `ToastProvider` vem da casca do Painel. */
export function UsersScreen() {
  const vm = useUsers();

  return <UsersView {...vm} />;
}

export type * from "./types-users";
